import { CreatePaperFeedback } from '@src/queries/CreatePaperFeedback'
import { GetPaperFeedbackCount } from '@src/queries/GetPaperFeedbackCount'
import { GET_PAPER_FEEDBACK_COUNT } from '@src/queries/Papers'
import { Cookies, setCookie } from '@src/utils/cookies'
import graphApi from '@src/utils/http-clients/graphApi'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import { getWordCount } from '@src/utils/wordCount'
import * as Cookie from 'js-cookie'
import { createLogic } from 'redux-logic'
import { getType } from 'typesafe-actions'
import { CREATE_PAPER_FEEDBACK } from '../../queries/Zoho'
import {
  CLICKSTREAM_CHECK_TYPES,
  CLICKSTREAM_EVENT_STATES,
  CLICKSTREAM_SUCCESS_NAMES,
} from '../analytics/constants'
import { authFlowComplete, hideCheggAuthModal } from '../auth/actions'
import { getFreeUser, getUserID } from '../auth/selectors'
import {
  getEditorText,
  getPaperMetadata,
  getSubjectTaxonomy,
} from '../document/selectors'
import site from '../site/site'
import siteConfig from '../site/siteConfig'
import { RootState } from '../types'
import { userSuccess } from '../userevents/actions'
import {
  createTicket,
  createTicketFailure,
  CreateTicketPayload,
  createTicketSuccess,
  CreateTicketSuccessPayload,
  getFeedbackCount,
  QUICK,
  setFeedbackDate,
  setShouldSubmitAfterLogin,
  setShouldSubmitOnload,
} from './actions'
import { ZOHO_COOKIE } from './selectors'
import { uploadPaper } from './utils'

export const createTicketLogic = createLogic<RootState, CreateTicketPayload>({
  type: getType(createTicket),
  async process({ getState, action }, dispatch, done) {
    const { description, email, feedbackTypes, turnAroundTime } = action.payload

    const state = getState()
    const { id: uploadUuid } = state.workspace
    const paperText = getEditorText(state)
    const paper = new File([paperText], 'paper.txt', {
      type: 'text-plain',
    })
    const files = [paper]

    try {
      const ids = await Promise.all(
        files.map(async file => {
          return await uploadPaper(file)
        })
      )
      const { data } = await graphApi.mutate<CreatePaperFeedback>({
        mutation: CREATE_PAPER_FEEDBACK,
        variables: {
          uploads: ids,
          uploadUuid,
          firstName: 'Student',
          lastName: site,
          email,
          description,
          wordCount: getWordCount(paperText),
          feedbackTypes,
          turnAroundTime,
          emailPDF: false,
          siteURL: window.location.host,
        },
      })

      dispatch(
        createTicketSuccess({
          ticketId: (data as CreatePaperFeedback).createPaperFeedback.feedbackId,
          feedbackTypes,
        })
      )

      dispatch(setFeedbackDate({ turnAroundDays: turnAroundTime === QUICK ? 1 : 2 }))
      done()
    } catch (e) {
      dispatch(createTicketFailure({ feedbackTypes }))
    }
    done()
  },
})

export const createTicketSuccessLogic = createLogic<
  RootState,
  CreateTicketSuccessPayload
>({
  type: getType(createTicketSuccess),
  process({ action, getState }, dispatch, done) {
    const { ticketId } = action.payload
    const state = getState()
    const COOKIE_NAME = `${ZOHO_COOKIE}-${getUserID(state)}`
    const twoHoursFromNow = new Date(Date.now() + 120 * 60 * 1000)
    Cookie.set(COOKIE_NAME, ticketId, { expires: twoHoursFromNow, secure: true })

    const { id: uploadUuid } = state.workspace
    const inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000)
    setCookie(Cookies.EcUploadPending, uploadUuid, {
      domain: siteConfig(state.site, LOCAL_OR_PLAYGROUND).cookieDomain,
      expires: inFiveMinutes,
    })

    dispatch(
      userSuccess({
        name: CLICKSTREAM_SUCCESS_NAMES.EC_SUBMITTED,
        state: CLICKSTREAM_EVENT_STATES.SUCCESS,
        metadata: getPaperMetadata(
          state,
          CLICKSTREAM_EVENT_STATES.EC_SUBMIT,
          CLICKSTREAM_CHECK_TYPES.EXPERT_CHECK
        ),
        subjectTaxonomy: getSubjectTaxonomy(state),
      })
    )
    done()
  },
})

export const getFeedbackCountLogic = createLogic<RootState>({
  type: getType(getFeedbackCount),
  validate({ getState, action }, allow, reject) {
    const isFreeUser = getFreeUser(getState())
    return isFreeUser ? allow(action) : reject(action)
  },
  async process() {
    graphApi.query<GetPaperFeedbackCount>({
      query: GET_PAPER_FEEDBACK_COUNT,
    })
  },
})

export const authFlowCompleteLogic = createLogic<RootState>({
  type: getType(authFlowComplete),
  validate({ getState, action }, allow, reject) {
    const { shouldSubmitAfterLogin } = getState().expertCheck
    return shouldSubmitAfterLogin ? allow(action) : reject(action)
  },
  process({ getState, action }, dispatch, done) {
    dispatch(setShouldSubmitOnload({ shouldSubmit: true }))
    dispatch(setShouldSubmitAfterLogin({ shouldSubmitAfterLogin: false }))

    done()
  },
})

export const hideAuthModalLogic = createLogic<RootState>({
  type: getType(hideCheggAuthModal),
  validate({ getState, action }, allow, reject) {
    const { shouldSubmitAfterLogin } = getState().expertCheck
    return shouldSubmitAfterLogin ? allow(action) : reject(action)
  },
  process({ getState, action }, dispatch, done) {
    dispatch(setShouldSubmitAfterLogin({ shouldSubmitAfterLogin: false }))

    done()
  },
})

export default [
  createTicketLogic,
  createTicketSuccessLogic,
  getFeedbackCountLogic,
  authFlowCompleteLogic,
  hideAuthModalLogic,
]



// WEBPACK FOOTER //
// ./src/state/expertcheck/logic.ts